<ng-container *ngIf="!(isPartOfArNavigation$  | async)">
    <div class="alert alert-danger">{{ 'aumico_reports_page_is_not_part_of_ar_navigation' | i18next }}</div>
</ng-container>
<ng-container *ngIf="(isPartOfArNavigation$  | async)" content [ngSwitch]="dataState">
    <div *ngSwitchCase="'loading'">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
    <ng-container *ngSwitchCase="'success'">
        <cashflow-info
            class="column-height-cfs"
            [cashflowClosingDifference]="cashflowClosingDifference"
            [cashflowOpeningDifference]="cashflowOpeningDifference"
        ></cashflow-info>

        <mismatch-disclaimer *ngIf="isVersionMismatch"></mismatch-disclaimer>

        <aumico-annualReport-cash-flow-statement-page
            [previousAnnualProfit]="previousAnnualProfit"
            [mappedBalanceFlis]="mappedFlis"
            [profitOfTheYearFli]="profitOfTheYearFli"
            [currentYearDate]="currentYearDate"
            [previousYearDate]="previousYearDate"
            [currency]="currency"
            [updateFlisAutomatically]="isVersionMismatch || updateFlisAutomatically"
            [cashAndCashEquivalentsFli]="cashAndCashEquivalentsFli"
            [previousOpeningCashAndCashEquivalents]="previousOpeningCashAndCashEquivalents"
            [previousClosingCashAndCashEquivalents]="previousClosingCashAndCashEquivalents"
            [savedCashFlowStatement]="currentAnnualReportCashFlowStatement"
            [autofillApplied]="autofillApplied"
            [reportLocale]="reportLocale"
            [isSavedClicked]="isSavedClicked"
            [previousTotalCaptions]="totalCaptions"
            [operatingActivitiesTitle]="operatingActivitiesTitle"
            [investingActivitiesTitle]="investingActivitiesTitle"
            [financingActivitiesTitle]="financingActivitiesTitle"
            [cashflowFromUploadAutofill]="cashflowFromUploadAutofill"
            (validityChange)="onValidityChange($event)"
            (currentCashflowStatementTotal)="onCurrentCashflowStatementTotalChange($event)"
            (previousCashflowStatementTotal)="onPreviousCashflowStatementTotalChange($event)"
            (differenceInTotal)="onDifferenceInTotal($event.previousTotal, $event.currentTotal)"
        >
        </aumico-annualReport-cash-flow-statement-page>
    </ng-container>

    <div *ngSwitchCase="'error'" class="alert alert-danger">
        {{ 'aumico_reports_required_data_not_completed' | i18next }}
    </div>
    <div *ngSwitchDefault class="alert alert-danger">UNKNOWN STATE</div>
</ng-container>
<ng-template #footerTemplate>
    <aum-action-bar-pure
        [extraActionButtons]="footerExtraButtonActions"
        nextButtonPrefixText="{{ nextStepPrefix | i18next }}"
        nextButtonText="{{ nextStepLabel | i18next }}"
        [nextButtonAction]="proceedButtonClicked"
        nextButtonRouterLink="../{{ nextStepPath }}"
        [nextButtonDisabled]="disableProceedButton"
        backButtonPrefixText="{{ previousStepPrefix | i18next }}"
        backButtonText="{{ previousStepLabel | i18next }}"
        backButtonRouterLink="../{{ previousStepPath }}"
        [backButtonIcon]="previousStepIcon"
    ></aum-action-bar-pure>
</ng-template>
